module.exports = __webpack_public_path__ + "static/media/camping_accessories.226e93f5.webp";